import { ListItem } from '../ListItem';

export class CommunicationType {

    static List(): ListItem[]  {

      let list: ListItem[] = [
          { "id": -1, "name": "none" },
          { "id": 0, "name": "unknown" },
          { "id": 1, "name": "email" },
          { "id": 2, "name": "sms" },
          { "id": 3, "name": "mms" },
          { "id": 4, "name": "postal" }
        ];

        return list;    
    }

    static Name(id: number): string  {

        let rtn: string = "";

        CommunicationType.List().forEach(obj => {

                if (obj.id == id)
                {
                    rtn = obj.name;
                }

           });

        return rtn;

    }

    
    static Value(name: string): number  {

        let rtn: number = 0;

        CommunicationType.List().forEach(obj => {

                if (obj.name == name)
                {
                    rtn = obj.id;
                }

           });

        return rtn;

    }  
    
}
